/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Enforcement_TitleInputs */

const en_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enforcement Procedure`)
};

const de_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchsetzungsverfahren`)
};

const fr_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procedure d'application`)
};

const es_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procedimiento de ejecucion`)
};

const it_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procedura di applicazione`)
};

const nl_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handhavingsprocedure`)
};

const pl_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procedura egzekwowania`)
};

const fi_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täytäntöönpanomenettely`)
};

const da_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handhavelsesprocedure`)
};

const sv_a11y_statement_enforcement_title = /** @type {(inputs: A11y_Statement_Enforcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkstallighetsforfarande`)
};

/**
* | output |
* | --- |
* | "Enforcement Procedure" |
*
* @param {A11y_Statement_Enforcement_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_enforcement_title = /** @type {((inputs?: A11y_Statement_Enforcement_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Enforcement_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_enforcement_title(inputs)
	if (locale === "fr") return fr_a11y_statement_enforcement_title(inputs)
	if (locale === "es") return es_a11y_statement_enforcement_title(inputs)
	if (locale === "it") return it_a11y_statement_enforcement_title(inputs)
	if (locale === "nl") return nl_a11y_statement_enforcement_title(inputs)
	if (locale === "pl") return pl_a11y_statement_enforcement_title(inputs)
	if (locale === "fi") return fi_a11y_statement_enforcement_title(inputs)
	if (locale === "da") return da_a11y_statement_enforcement_title(inputs)
	if (locale === "sv") return sv_a11y_statement_enforcement_title(inputs)
	return en_a11y_statement_enforcement_title(inputs)
});